export function Loading() {
  return (
    <div className="loading">
      <div className="double-bounce1" />
      <div className="double-bounce2" />
    </div>
  );
}
